import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, sm, xs },
} = constants.breakpoints;
const { textXSObj } = typographyStyles;

const grey = constants.colors.ui.neutral[400];
const greyLight = constants.colors.ui.neutral[100];
const green = constants.colors.status.success[300];

export const iconCss = ({
  ircStyleEnabled = false,
  isPowerWord = false,
  isDoneActivity = false,
}) => ({
  marginRight: "8px",
  width: "24px",

  ...(isPowerWord && {
    fill: "transparent",
    path: {
      stroke: "currentColor",
    },
  }),

  ...(ircStyleEnabled && {
    border: "1px solid black",
    borderRadius: "50%",

    circle: {
      fill: isDoneActivity ? green : greyLight,
      stroke: greyLight,
    },

    path: {
      strokeWidth: "3",
    },
  }),
});

export const activityInfoContentCss = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  maxWidth: "100%",
  marginRight: "4px",
};

export const activityInfoContentTextCss = {
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  margin: 0,
};

export const challengesRewardsContentCss = {
  marginLeft: "auto",
};

export const listContainerCss = {
  padding: "16px",

  [mediaQuery.downTo(xs)]: {
    padding: "24px 40px",
  },

  [mediaQuery.downTo(md)]: {
    padding: "24px 24px 32px 24px",
  },
};

export const containerCss = (isIrcEnabled) => ({
  display: "flex",
  flexDirection: "column",
  margin: 0,
  padding: 0,
  ...(isIrcEnabled && { marginTop: "16px" }),
});

export const headerCss = [
  {
    margin: "8px 0",
    color: grey,
    textAlign: "left",
    textTransform: "uppercase",
    lineHeight: "1rem",
    letterSpacing: "1px",
  },
  textXSObj,
];

export const dividerCss = {
  borderBottom: `1px solid ${greyLight}`,
  margin: "0 16px",

  [mediaQuery.downTo(sm)]: {
    margin: "0 40px",
  },

  [mediaQuery.downTo(md)]: {
    margin: "0",
  },
};

export const attachmentsGroupDividerCss = {
  borderBottom: `1px solid ${greyLight}`,
  width: "120%",
  margin: "32px -10% 32px -8%",
  [mediaQuery.upTo(md)]: {
    width: "100%",
    margin: "32px 0",
  },
};

export const subjectTitleCss = {
  fontWeight: "700",
  fontSize: "12px",
  lineHeight: "133%",
  letterSpacing: " 1px",
  textTransform: "uppercase",
  color: grey,
  marginTop: "0px",
  marginBottom: "16px",
};

export const formativeContainer = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};
